<script>
// import { mapActions, mapMutations } from 'vuex'
import DocumentGrid from '../Document/DocumentGrid'
export default {
  name: 'StudentDocumentsTab',
  props: ['studentId'],
  components: {
    DocumentGrid
  },
  data () {
    return {
      roleForm: this.$store.state.students.roleForm
    }
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="">
    <DocumentGrid :entityItemId="studentId"/>
  </div>
</template>

<style>
</style>
